{
  "top-salons-page": {
    "text": {
      "title": "Top Salons",
      "hint": "Entdecke die beliebtesten Beauty-Salons in deinen Lieblingsstädten.",
      "country-label": "Land",
      "country": {
        "DE": "Deutschland",
        "CH": "Schweiz",
        "NL": "Niederlande"
      }
    },
    "meta": {
      "title": "Top Salons | Beauty Booking",
      "description": "Entdecke die beliebtesten Beauty-Salons in Deutschland, der Schweiz und den Niederlanden."
    }
  }
}
